module.exports = __webpack_public_path__ + "static/media/Home-PinkWave1.841d0b1b.svg";